import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { GlobalAlertService } from "src/app/services/global-alert.service";
import { GlobalService } from "src/app/services/global.service";
import { Router } from "@angular/router";
import * as $ from "jquery";
import * as moment from "moment";
import Swal from "sweetalert2";
import { ExcelService } from "src/app/services/excel.service";
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as XLSX from "xlsx";

@Component({
  selector: "app-user-ticket",
  templateUrl: "./user-ticket.component.html",
  styleUrls: ["./user-ticket.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush, // ← Solo re-renderiza cuando cambia referencia
})
export class UserTicketComponent implements OnInit, OnDestroy {

  // ─── Estado general ────────────────────────────────────────────────────────
  USERDATALIWA: any;
  tickets: any[] = [];
  idTicket: any;
  clientClass: any;
  idCliente: any;
  banderaRool: boolean = false;
  Registrar: boolean = false;

  // ─── Paginación local (evita renderizar 1000 filas de golpe) ───────────────
  paginaActual: number = 1;
  registrosPorPagina: number = 50;
  totalPaginas: number = 1;
  ticketsPaginados: any[] = [];

  // ─── Búsqueda local (sin DataTable) ───────────────────────────────────────
  textoBusqueda: string = "";
  ticketsFiltrados: any[] = [];

  // ─── Vista ────────────────────────────────────────────────────────────────
  vistaActiva: 'tabla' | 'graficos' = 'tabla';

  // Índices columnas todos-tickets (Creation_Date duplicada se colapsa → -1 en índices posteriores)
  // [0]Id_Tickets [1]Semaforo [2]Estado [3]Beneficiario [4]Description [5]Creation_Date
  // [6]Menu [7]Hora_Inicial [8]Hora_Final [9]Dia_Agendado [10]Id_Maintenance [11]Cedula
  // [12]Tipo_Visita [13]Estado_Agenda [14]Clasificacion [15]SubMenu1 [16]SubMenu2 [17]SubMenu3

  // ─── Gráficos ─────────────────────────────────────────────────────────────
  chartSemaforo:   any = {};
  chartMenu:       any = {};
  chartSubMenu1:   any = {};
  chartSubMenu2:   any = {};
  chartSubMenu3:   any = {};
  chartTendencia:  any = {};
  chartAntiguedad: any = {};
  chartEstados:    any = {};
  chartSeccional:  any = {};
  chartHeatmap:    any = {};
  chartSeccionalAltura: number = 300;
  chartSeccionalExpandido: boolean = false;
  chartSeccionalTotal: number = 0;
  chartSubMenu1Total: number = 0;
  chartSubMenu1Expandido: boolean = false;
  chartSubMenu1Altura: number = 300;
  chartSubMenu2Total: number = 0;
  chartSubMenu2Expandido: boolean = false;
  chartSubMenu2Altura: number = 300;
  chartSubMenu3Total: number = 0;
  chartSubMenu3Expandido: boolean = false;
  chartSubMenu3Altura: number = 300;

  // ─── Excel masivo ─────────────────────────────────────────────────────────
  Toexcel: any[] = [];
  infoVisitaTecnica: any[] = [];
  arrayBuffer: any;
  file: File;
  MEDIDORESEXCEL: any;
  fechaI: string;
  fechaF: string;
  descripcion: string;

  email = [
    'camilo.mendoza@sunpoweresp.co',
    'juancamilomendozavillegas14@gmail.com',
  ];

  private dtInstance: any = null;

  constructor(
    public global: GlobalService,
    public modalService: NgbModal,
    public ruta: Router,
    public alerta: GlobalAlertService,
    private spinner: NgxSpinnerService,
    private excelService: ExcelService,
    private cdr: ChangeDetectorRef
  ) {
    this.global.initData();
  }

  ngOnInit(): void {
    this.spinner.show();
    this.idCliente = this.global.Id_Client;
    this.global.Id_Ticket = "";
    this.global.idEdit = undefined;
    this.clientClass = this.global.CLIENTDATALIWA[8];
    this.listadoTickets();
  }

  ngOnDestroy(): void {
    this.destruirDataTable();
  }

  // ─── Carga de tickets ──────────────────────────────────────────────────────
  listadoTickets(): void {
    const pdataO: any = { option: "todos-tickets", idCliente: this.global.Id_Client};

    this.global.consultar(pdataO, (err: any, response: any) => {
      if (err) {
        console.error("Error en la consulta:", err);
        this.spinner.hide();
        return;
      }

      // Asignar referencia nueva para que OnPush detecte el cambio
      this.tickets = response ?? [];
      this.ticketsFiltrados = [...this.tickets];
      this.totalPaginas = Math.ceil(this.ticketsFiltrados.length / this.registrosPorPagina);
      this.paginaActual = 1;
      this.actualizarPagina();
      this.actualizarGraficos();

      this.spinner.hide();

      // Notificar a OnPush que hay cambios
      this.cdr.markForCheck();
    });
  }

  // ─── Búsqueda y filtrado local ─────────────────────────────────────────────
  buscar(): void {
    const texto = this.textoBusqueda.toLowerCase().trim();

    if (!texto) {
      this.ticketsFiltrados = [...this.tickets];
    } else {
      this.ticketsFiltrados = this.tickets.filter((t) =>
        // Busca en las columnas más relevantes: id, nombre, estado, menú
        [t[0], t[3], t[2], t[6], t[7]]
          .some((col) => col && String(col).toLowerCase().includes(texto))
      );
    }

    this.totalPaginas = Math.ceil(this.ticketsFiltrados.length / this.registrosPorPagina) || 1;
    this.paginaActual = 1;
    this.actualizarPagina();
    this.actualizarGraficos();
    this.cdr.markForCheck();
  }

  // ─── Paginación ────────────────────────────────────────────────────────────
  actualizarPagina(): void {
    const inicio = (this.paginaActual - 1) * this.registrosPorPagina;
    const fin = inicio + this.registrosPorPagina;
    // Slice crea nueva referencia → OnPush detecta el cambio
    this.ticketsPaginados = this.ticketsFiltrados.slice(inicio, fin);
  }

  cambiarPagina(pagina: number): void {
    if (pagina < 1 || pagina > this.totalPaginas) return;
    this.paginaActual = pagina;
    this.actualizarPagina();
    this.cdr.markForCheck();
  }

  cambiarRegistrosPorPagina(cantidad: number): void {
    this.registrosPorPagina = cantidad;
    this.totalPaginas = Math.ceil(this.ticketsFiltrados.length / this.registrosPorPagina) || 1;
    this.paginaActual = 1;
    this.actualizarPagina();
    this.cdr.markForCheck();
  }

  get paginasVisibles(): number[] {
    const rango = 3;
    const inicio = Math.max(1, this.paginaActual - rango);
    const fin = Math.min(this.totalPaginas, this.paginaActual + rango);
    const paginas = [];
    for (let i = inicio; i <= fin; i++) paginas.push(i);
    return paginas;
  }

  // ─── Semáforo ──────────────────────────────────────────────────────────────
  // Ya viene calculado desde el backend en la columna Clasificacion
  // Solo necesitamos mapear a la clase CSS
  badgeClass(clasificacion: string): string {
    switch (clasificacion) {
      case "CRITICO":  return "badge badge-danger";
      case "MODERADO": return "badge badge-warning";
      case "LEVE":     return "badge badge-leve";
      case "CERRADO":  return "badge badge-success";
      default:         return "badge badge-secondary";
    }
  }

  // ─── Acciones sobre tickets ────────────────────────────────────────────────
  createTicket(): void {
    this.ruta.navigateByUrl("/crear-ticket");
  }

  ver(data: any): void {
    this.global.Id_Ticket = data[0];
    localStorage.setItem("Id_Ticket", data[0]);

    const pdataTicket = {
      option: "insertar2",
      texto: `SELECT A.*,
        (SELECT C.Nombre FROM db_liwa.Seccionales C WHERE C.Id_seccional = A.Id_Seccional) AS Nombre_seccional,
        (SELECT E.Nombre FROM db_liwa.tipoProyecto E WHERE E.id_tipoProyecto = A.Id_Proyecto) AS Nombre_proyecto,
        A.Id_Proyecto FROM db_liwa.EncuestasAOM A
        INNER JOIN db_liwa.Tickets_New T ON T.Id_Beneficiario = A.Id_Encuesta
        WHERE A.NUI LIKE '%${data[0]}%' OR T.Id_Tickets LIKE '%${data[0]}%';`,
    };
    this.global.consultar(pdataTicket, (err: any, response: any) => {
      if (response.length === 1) {
        this.global.informacion = response;
        window.localStorage.setItem("informacion", JSON.stringify(this.global.informacion));
        this.global.informacion = JSON.parse(window.localStorage.getItem("informacion"));
        this.ruta.navigateByUrl("/ver-ticket");
      } else {
        this.alerta.descErr("No se encontró el beneficiario relacionado.");
      }
    });
  }

  modificarTiket(data: any): void {
    this.global.banderaModificaionTicket = true;
    this.global.informacionBeneficiario = data;
    this.global.Id_Ticket = data[0];
    this.ruta.navigateByUrl("/historico-usuario");
  }

  deleteVal(data: any): void {
    Swal.fire({
      title: "<strong>¿Está seguro que desea eliminar el ticket?</strong>",
      icon: "question",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#093579",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Si, estoy seguro",
    }).then((result) => {
      if (result.isConfirmed) {
        this.eliminar(data);
      }
    });
  }

  eliminar(data: any): void {
    this.spinner.show();
    const query = `UPDATE db_liwa.Tickets_New SET IsDelete = '1' WHERE Id_Tickets = '${data}';`;
    const pdata1 = { option: "insertar", texto: query };

    $.ajax({
      data: pdata1, cache: false, dataType: "json", type: "post",
      url: "https://www.php.engenius.com.co/DatabaseLIWA.php",
    }).then(() => {
      this.alerta.descValid("El ticket se ha cerrado con éxito");
      this.enviarcorreo(data);
      this.spinner.hide();
      this.listadoTickets(); // ← recarga solo los datos, no todo el componente
    }).catch(() => { this.spinner.hide(); });
  }

  Agendar(idTicket: any): void {
    this.global.Id_Ticket = idTicket;
    this.global.withoutTicket = false;
    this.global.isAgended = true;
    this.ruta.navigateByUrl("/crear-visita");
  }

  // ─── Correo / SMS ──────────────────────────────────────────────────────────
  enviarcorreo(idTicket: any): void {
    const pdata9 = {
      option: "mailC",
      ticket: idTicket.toString(),
      texto: "Terminado",
      user: this.global.USERDATALIWA[8],
      novedad: "La PQRS ha sido cerrada por el usuario.",
    };
    this.global.consultar2(pdata9, async (err: any, response2: any) => {});
  }

  enviarcorreoCreado(infoCorreo: any, idTk: any): void {
    setTimeout(() => {
      const pdata9 = {
        option: "mail", ticket: idTk, Seccional: "hg",
        descr: infoCorreo[8], type: 1, contacto: infoCorreo[11],
        tel: infoCorreo[10], user: this.global.UserName, municipio: infoCorreo,
      };
      this.global.consultar(pdata9, () => {});
    }, 500);
  }

  eviarSMS(infoSMS: any, idTk: any): void {
    setTimeout(() => {
      const pdata9 = {
        number: "57" + infoSMS[10],
        message: `se acaba de agregar un ticket de tipo : ${infoSMS[4]}, realizada el dia ${infoSMS[12]} con id Ticket :${idTk}, cargado de manera masiva por : ${this.global.UserName}`,
        type: "1",
      };
      this.global.consultarSMS(pdata9, () => {});
    }, 500);
  }

  // ─── Modales ───────────────────────────────────────────────────────────────
  modal(content: any): void {
    this.modalService.open(content, { ariaLabelledBy: "modal-vinculate" }).result.then(() => {}, () => {});
  }

  openEditRate(content: any, Id_Ticket: any): void {
    const pdata9 = {
      option: "insertar2",
      texto: `SELECT M.Visit_Hour_init, M.Visit_Hour_finish, M.Visit_day,
        (SELECT UserName FROM db_liwa.User WHERE Id_User = M.Id_Technical) AS Nombre_Tecnico
        FROM db_liwa.Maintenance_new M WHERE Id_Ticket = '${Id_Ticket}' AND IsDelete=0;`,
    };
    this.global.consultar(pdata9, (err: any, response9: any) => {
      this.infoVisitaTecnica = response9;
      this.modalService.open(content, { ariaLabelledBy: "modal-editRate" }).result.then(() => {}, () => {});
    });
  }

  openDescripcion(content: any, itemValue: any): void {
    this.descripcion = itemValue;
    this.modalService.open(content, { ariaLabelledBy: "modal-descripcion" });
  }

  // ─── Helpers visuales ─────────────────────────────────────────────────────
  importancia(data: any): string {
    if (data === "AAA") return "badge badge-danger";
    if (data === "AA")  return "badge badge-warning";
    if (data === "A")   return "badge badge-success";
    return "";
  }

  importanciaTitle(data: any): string {
    if (data === "AAA") return "URGENTE";
    if (data === "AA")  return "MEDIO";
    if (data === "A")   return "BAJO";
    return "";
  }

  formatt(item: any): string {
    return moment(item).format("YYYY/MM/DD HH:mm");
  }

  // trackBy para que *ngFor no re-renderice filas que no cambiaron
  trackById(index: number, ticket: any): any {
    return ticket[0]; // Id_Tickets
  }

  // ─── Gráficos ─────────────────────────────────────────────────────────────
  private actualizarGraficos(): void {
    this.buildChartSeccional();
    this.buildChartSemaforo();
    this.buildChartMenu();
    this.buildChartSubMenu(1, 15, '#26C6DA');
    this.buildChartSubMenu(2, 16, '#FF69B4');
    this.buildChartSubMenu(3, 17, '#FFA726');
    this.buildChartTendencia();
    this.buildChartAntiguedad();
    this.buildChartEstados();
    this.buildChartHeatmap();
  }

  toggleSeccional(): void {
    this.chartSeccionalExpandido = !this.chartSeccionalExpandido;
    this.buildChartSeccional();
    this.cdr.markForCheck();
  }

  private buildChartSemaforo(): void {
    const colores: Record<string, string> = {
      'CRITICO':  '#dc3545',
      'MODERADO': '#ffc107',
      'LEVE':     '#bcb223',
      'CERRADO':  '#28a745',
    };
    const mapa = new Map<string, number>([['LEVE',0],['MODERADO',0],['CRITICO',0],['CERRADO',0]]);
    this.ticketsFiltrados.forEach(t => {
      const c = String(t[14] ?? '').toUpperCase();   // [14] = Clasificacion
      if (mapa.has(c)) mapa.set(c, mapa.get(c)! + 1);
    });
    this.chartSemaforo = {
      tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
      legend: { bottom: '2%', left: 'center', textStyle: { fontSize: 11 } },
      series: [{
        type: 'pie', radius: ['42%', '68%'], center: ['50%', '44%'],
        avoidLabelOverlap: false,
        label: { show: true, fontSize: 11, formatter: '{b}\n{c}' },
        data: Array.from(mapa.entries())
          .filter(([, v]) => v > 0)
          .map(([name, value]) => ({ name, value, itemStyle: { color: colores[name] ?? '#aaa' } })),
      }],
    };
  }

  private buildChartMenu(): void {
    const mapa = new Map<string, number>();
    this.ticketsFiltrados.forEach(t => {
      const m = String(t[6] || 'Sin tipo');
      mapa.set(m, (mapa.get(m) ?? 0) + 1);
    });
    const sorted = Array.from(mapa.entries()).sort((a, b) => b[1] - a[1]);
    const colores = ['#4A90D9','#7B68EE','#FF69B4','#FFA726','#26C6DA','#66BB6A','#EF5350'];
    this.chartMenu = {
      tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
      grid: { left: '3%', right: '8%', bottom: '3%', top: '3%', containLabel: true },
      xAxis: { type: 'value' },
      yAxis: { type: 'category', data: sorted.map(x => x[0]), axisLabel: { fontSize: 11 } },
      series: [{
        type: 'bar',
        data: sorted.map((x, i) => ({ value: x[1], itemStyle: { color: colores[i % colores.length], borderRadius: [0, 4, 4, 0] } })),
        label: { show: true, position: 'right', fontSize: 12, fontWeight: 'bold' },
      }],
    };
  }

  private buildChartTendencia(): void {
    const mapa = new Map<string, number>();
    this.ticketsFiltrados.forEach(t => {
      if (!t[5]) return;
      const d = new Date(t[5]);
      const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
      mapa.set(key, (mapa.get(key) ?? 0) + 1);
    });
    const sorted = Array.from(mapa.entries()).sort((a, b) => a[0].localeCompare(b[0]));
    this.chartTendencia = {
      tooltip: { trigger: 'axis' },
      grid: { left: '3%', right: '4%', bottom: '12%', top: '5%', containLabel: true },
      xAxis: { type: 'category', data: sorted.map(x => x[0]), axisLabel: { rotate: 45, fontSize: 11 } },
      yAxis: { type: 'value', minInterval: 1 },
      series: [{
        type: 'line', data: sorted.map(x => x[1]),
        smooth: true, symbol: 'circle', symbolSize: 6,
        lineStyle: { color: '#093579', width: 2 },
        itemStyle: { color: '#093579' },
        areaStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
          colorStops: [{ offset: 0, color: 'rgba(9,53,121,.35)' }, { offset: 1, color: 'rgba(9,53,121,.04)' }] } },
      }],
    };
  }

  private buildChartAntiguedad(): void {
    const grupos = [
      { label: '0 – 5 días',    min: 0,   max: 5,       color: '#26C6DA' },
      { label: '6 – 15 días',   min: 6,   max: 15,      color: '#66BB6A' },
      { label: '16 – 30 días',  min: 16,  max: 30,      color: '#FFA726' },
      { label: '31 – 60 días',  min: 31,  max: 60,      color: '#EF5350' },
      { label: '61 – 100 días', min: 61,  max: 100,     color: '#AB47BC' },
      { label: '101 – 150 días',min: 101, max: 150,     color: '#5C6BC0' },
      { label: '+150 días',     min: 151, max: Infinity, color: '#37474F' },
    ];
    const counts = grupos.map(g =>
      this.ticketsFiltrados.filter(t => { const d = +(t[1] ?? 0); return d >= g.min && d <= g.max; }).length
    );
    this.chartAntiguedad = {
      tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, formatter: (p: any) => `${p[0].name}: <b>${p[0].value} tickets</b>` },
      grid: { left: '3%', right: '5%', bottom: '5%', top: '10%', containLabel: true },
      xAxis: { type: 'category', data: grupos.map(g => g.label), axisLabel: { fontSize: 11 } },
      yAxis: { type: 'value', minInterval: 1 },
      series: [{
        type: 'bar',
        data: counts.map((v, i) => ({ value: v, itemStyle: { color: grupos[i].color, borderRadius: [4, 4, 0, 0] } })),
        label: { show: true, position: 'top', fontSize: 13, fontWeight: 'bold' },
      }],
    };
  }

  private buildChartSubMenu(nivel: 1 | 2 | 3, idx: number, color: string): void {
    const mapa = new Map<string, number>();
    this.ticketsFiltrados.forEach(t => {
      const v = t[idx];
      if (v && String(v).trim() && String(v).trim() !== '-') {
        const key = String(v).trim();
        mapa.set(key, (mapa.get(key) ?? 0) + 1);
      }
    });
    if (!mapa.size) {
      const empty = { title: { text: 'Sin datos', left: 'center', top: 'middle', textStyle: { color: '#aaa', fontSize: 13 } } };
      if (nivel === 1) { this.chartSubMenu1 = empty; this.chartSubMenu1Total = 0; this.chartSubMenu1Altura = 300; }
      else if (nivel === 2) { this.chartSubMenu2 = empty; this.chartSubMenu2Total = 0; this.chartSubMenu2Altura = 300; }
      else { this.chartSubMenu3 = empty; this.chartSubMenu3Total = 0; this.chartSubMenu3Altura = 300; }
      return;
    }
    const sorted = Array.from(mapa.entries()).sort((a, b) => b[1] - a[1]);
    const expandido = nivel === 1 ? this.chartSubMenu1Expandido : nivel === 2 ? this.chartSubMenu2Expandido : this.chartSubMenu3Expandido;
    const visible = expandido ? sorted : sorted.slice(0, 15);
    const altura = Math.max(300, visible.length * 28);
    const chart = {
      tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
      grid: { left: '3%', right: '8%', bottom: '3%', top: '3%', containLabel: true },
      xAxis: { type: 'value' },
      yAxis: { type: 'category', data: visible.map(x => x[0]), axisLabel: { fontSize: 10, width: 180, overflow: 'truncate' } },
      series: [{
        type: 'bar', data: visible.map(x => x[1]),
        itemStyle: { color, borderRadius: [0, 4, 4, 0] },
        label: { show: true, position: 'right', fontSize: 11 },
      }],
    };
    if (nivel === 1) { this.chartSubMenu1 = chart; this.chartSubMenu1Total = sorted.length; this.chartSubMenu1Altura = altura; }
    else if (nivel === 2) { this.chartSubMenu2 = chart; this.chartSubMenu2Total = sorted.length; this.chartSubMenu2Altura = altura; }
    else { this.chartSubMenu3 = chart; this.chartSubMenu3Total = sorted.length; this.chartSubMenu3Altura = altura; }
  }

  toggleSubMenu(nivel: 1 | 2 | 3): void {
    if (nivel === 1) this.chartSubMenu1Expandido = !this.chartSubMenu1Expandido;
    else if (nivel === 2) this.chartSubMenu2Expandido = !this.chartSubMenu2Expandido;
    else this.chartSubMenu3Expandido = !this.chartSubMenu3Expandido;
    const colors: Record<number, string> = { 1: '#26C6DA', 2: '#FF69B4', 3: '#FFA726' };
    const idxMap: Record<number, number> = { 1: 15, 2: 16, 3: 17 };
    this.buildChartSubMenu(nivel, idxMap[nivel], colors[nivel]);
    this.cdr.markForCheck();
  }

  private buildChartEstados(): void {
    const mapa = new Map<string, number>();
    this.ticketsFiltrados.forEach(t => {
      const est = String(t[2] || 'Sin estado');
      mapa.set(est, (mapa.get(est) ?? 0) + 1);
    });
    const sorted = Array.from(mapa.entries()).sort((a, b) => b[1] - a[1]).slice(0, 12);
    this.chartEstados = {
      tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
      grid: { left: '3%', right: '8%', bottom: '3%', top: '3%', containLabel: true },
      xAxis: { type: 'value' },
      yAxis: { type: 'category', data: sorted.map(x => x[0]), axisLabel: { fontSize: 10, width: 200, overflow: 'truncate' } },
      series: [{
        type: 'bar', data: sorted.map(x => x[1]),
        itemStyle: { color: '#093579', borderRadius: [0, 4, 4, 0] },
        label: { show: true, position: 'right', fontSize: 11, fontWeight: 'bold' },
      }],
    };
  }

  private buildChartSeccional(): void {
    const mapa = new Map<string, number>();
    this.ticketsFiltrados.forEach(t => {
      const s = t[18] || 'Sin seccional';
      mapa.set(s, (mapa.get(s) ?? 0) + 1);
    });
    const sorted = Array.from(mapa.entries()).sort((a, b) => b[1] - a[1]);
    this.chartSeccionalTotal = sorted.length;
    const visible = this.chartSeccionalExpandido ? sorted : sorted.slice(0, 15);
    this.chartSeccionalAltura = Math.max(300, visible.length * 28);
    this.chartSeccional = {
      tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
      grid: { left: '3%', right: '5%', bottom: '3%', top: '3%', containLabel: true },
      xAxis: { type: 'value', splitLine: { lineStyle: { type: 'dashed' } } },
      yAxis: { type: 'category', data: visible.map(x => x[0]), axisLabel: { fontSize: 11 } },
      series: [{
        type: 'bar', data: visible.map(x => x[1]),
        itemStyle: { color: '#4A90D9', borderRadius: [0, 4, 4, 0] },
        label: { show: true, position: 'right', fontSize: 11 },
      }],
    };
  }

  private buildChartHeatmap(): void {
    const meses = new Set<string>();
    const seccionales = new Set<string>();
    this.ticketsFiltrados.forEach(t => {
      if (t[5]) {
        const d = new Date(t[5]);
        meses.add(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`);
      }
      if (t[18]) seccionales.add(t[18]);
    });
    const mesesArr = Array.from(meses).sort();
    const seccionalesArr = Array.from(seccionales).sort();
    const countMap = new Map<string, number>();
    this.ticketsFiltrados.forEach(t => {
      if (!t[5] || !t[18]) return;
      const d = new Date(t[5]);
      const mes = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
      const key = `${t[18]}__${mes}`;
      countMap.set(key, (countMap.get(key) ?? 0) + 1);
    });
    const data: any[] = [];
    seccionalesArr.forEach((sec, yi) => {
      mesesArr.forEach((mes, xi) => {
        const val = countMap.get(`${sec}__${mes}`) ?? 0;
        if (val > 0) data.push([xi, yi, val]);
      });
    });
    const maxVal = data.length ? Math.max(...data.map(d => d[2])) : 1;
    this.chartHeatmap = {
      tooltip: {
        position: 'top',
        formatter: (p: any) => `<b>${seccionalesArr[p.data[1]]}</b><br>${mesesArr[p.data[0]]}: <b>${p.data[2]} tickets</b>`,
      },
      grid: { left: '2%', right: '2%', bottom: '15%', top: '3%', containLabel: true },
      xAxis: { type: 'category', data: mesesArr, axisLabel: { rotate: 45, fontSize: 10 } },
      yAxis: { type: 'category', data: seccionalesArr, axisLabel: { fontSize: 10 } },
      visualMap: {
        min: 0, max: maxVal, calculable: true,
        orient: 'horizontal', left: 'center', bottom: '2%',
        inRange: { color: ['#e8f4f8', '#4A90D9', '#093579'] },
      },
      series: [{
        type: 'heatmap', data,
        label: { show: true, fontSize: 9 },
        emphasis: { itemStyle: { shadowBlur: 10, shadowColor: 'rgba(0,0,0,.5)' } },
      }],
    };
  }

  verArchivo(): void {
    window.open("https://php.engenius.com.co/Formatos/Excel/Ejemplo_Carga_Masiva_PQRS.xlsx", "_blank");
  }

  // ─── Normalización y validación de tipificaciones ──────────────────────────
  private normalizarTipificacion(s: string): string {
    if (!s) return s;
    return s
      .replace(/ñ/g, '__NIO__').replace(/Ñ/g, '__NIO__')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/__NIO__/g, 'Ñ')
      .toUpperCase()
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  private readonly TIPIFICACIONES_VALIDAS: Record<string, string[]> = {
    // SubMenu1 por Tipo_PQR
    'MENU:PETICION': ['CONSULTA DE INFORMACION','SOLICITUD DE FACTURA Y/O COMPROBANTE','CAMBIO DE TITULARIDAD','SOLICITUD DE TRASLADO','AUSENCIA DE EQUIPOS','SOLICITUD DE DESESTIMIENTO'],
    'MENU:QUEJA':    ['ATENCION DEFICIENTE','INCONFORMIDAD CON FACTURACION'],
    'MENU:RECLAMO':  ['DAÑO'],
    'MENU:OTROS':    ['GESTION DE CARTERA','LLAMADA DE INFORMACION','GESTION SOCIAL','RESULTADO OPERATIVO'],
    // SubMenu2 por SubMenu1
    'SUB1:CONSULTA DE INFORMACION':                  ['INFORMACION DEL CONTRATO','ACUERDOS INICIALES'],
    'SUB1:SOLICITUD DE FACTURA Y/O COMPROBANTE':     ['COPIA DE FACTURA','COPIA DE COMPROBANTE DE PAGO','SOLICITUD ESTADO DE CARTERA'],
    'SUB1:CAMBIO DE TITULARIDAD':                    ['-'],
    'SUB1:SOLICITUD DE TRASLADO':                    ['-'],
    'SUB1:AUSENCIA DE EQUIPOS':                      ['-'],
    'SUB1:SOLICITUD DE DESESTIMIENTO':               ['-'],
    'SUB1:ATENCION DEFICIENTE':                      ['QUEJAS ADMINISTRATIVAS','INTERRUPCIONES EN LA PRESTACION DEL SERVICIO','NO ATENCION DE CONDICIONES DE SEGURIDAD O RIESGO','TERMINACION DEL CONTRATO','SUSPENSION O CORTE DEL SERVICIO SIN PREVIO AVISO O SIN CAUSA APARENTE','AFECTACION AMBIENTAL','ESTADO DE LA INFRAESTRUCTURA','FALLAS EN LA CONEXION DEL SERVICIO','NO CONEXION DEL SERVICIO'],
    'SUB1:INCONFORMIDAD CON FACTURACION':            ['COBROS INOPORTUNOS','COBRO POR SERVICIOS NO PRESTADOS','DATOS GENERALES INCORRECTOS','COBRO MULTIPLE Y/O ACUMULADO','ENTREGA INOPORTUNA O NO ENTREGA DE LA FACTURA','COBRO POR CONEXION, RECONEXION, REINSTALACION','COBRO DE CARGOS RELACIONADOS A CARTERA Y/O ACUERDOS DE PAGO','SUBSIDIOS Y CONTRIBUCIONES','DESCUENTO POR PREDIO DESOCUPADO','INCUMPLIMIENTO O NEGACION DEL ACUERDO DE SUSPENSION DEL SERVICIO','ESTRATO INCORRECTO','CLASE DE USO INCORRECTO (COMERCIAL, INDUSTRIAL, OFICIAL, OTROS)','TARIFA INCORRECTA','COBROS POR PROMEDIO','SUSCRIPTOR QUE EFECTUA EL PAGO PERO ESTE NO ES APLICADO POR LA EMPRESA EN LA FACTURACION','INCONFORMIDAD POR LA NORMALIZACION DEL SERVICIO','NEGACION DE LA SOLICITUD DE SUSPENSION'],
    'SUB1:DAÑO':                                     ['SISTEMA FUNCIONAL','REPOSICION','SISFV NO ENCONTRADA','SISFV ABANDONADO','RESTRICCIONES ACCESO','AUSENTE','EQUIPOS MODIFICADOS(HOMOLOGACION)'],
    'SUB1:GESTION DE CARTERA':                       ['ACUERDO DE PAGO','PAGO MENSUAL','SIN PROMESA','EQUIVOCADO','BUZON DE MENSAJES','MENSAJE DE TEXTO','NO CONTESTA','MENSAJE CON TERCERO'],
    'SUB1:LLAMADA DE INFORMACION':                   ['REPORTE GENERAL','NO CONTESTA','EQUIVOCADO','BUZON DE MENSAJES','MENSAJE CON TERCERO'],
    'SUB1:GESTION SOCIAL':                           ['HURTO PARCIAL','HURTO COMPLETO','TRASLADO NO AUTORIZADO','SOLUCION ABANDONADA','RESTRICCIONES DE ACCESO'],
    'SUB1:RESULTADO OPERATIVO':                      ['REPOSICION','SISFV NO ENCONTRADA','RESTRICCIONES ACCESO','AUSENTE','AUSENCIA DE EQUIPOS','SUSPENSION DEL SERVICIO','RECONEXION DEL SERVICIO'],
  };

  // SubMenu1 que requieren SubMenu3 de facturación
  private readonly SUB1_REQUIERE_SUB3 = new Set(['DAÑO','GESTION SOCIAL','RESULTADO OPERATIVO']);
  private readonly VALID_SUB3 = ['BLOQUEA FACTURACION','NO BLOQUEA FACTURACION','DESCUENTO COMERCIAL'];

  private validarFila(row: any, idx: number): string | null {
    const menu  = this.normalizarTipificacion(String(row.Tipo_PQR  || ''));
    const sub1  = this.normalizarTipificacion(String(row.Submenu1  || ''));
    const sub2  = this.normalizarTipificacion(String(row.Submenu2  || ''));
    const sub3  = this.normalizarTipificacion(String(row.Submenu3  || ''));
    const fila  = `Fila ${idx + 2}`;

    const menuValidos = ['PETICION','QUEJA','RECLAMO','OTROS'];
    if (!menuValidos.includes(menu))
      return `${fila}: Tipo_PQR "${row.Tipo_PQR}" no es válido. Permitidos: ${menuValidos.join(', ')}`;

    const sub1Validos = this.TIPIFICACIONES_VALIDAS[`MENU:${menu}`] || [];
    if (!sub1Validos.includes(sub1))
      return `${fila}: Submenu1 "${row.Submenu1}" no es válido para ${menu}. Permitidos: ${sub1Validos.join(', ')}`;

    const sub2Validos = this.TIPIFICACIONES_VALIDAS[`SUB1:${sub1}`] || [];
    if (sub2Validos.length && !sub2Validos.includes(sub2))
      return `${fila}: Submenu2 "${row.Submenu2}" no es válido para ${sub1}. Permitidos: ${sub2Validos.join(', ')}`;

    if (this.SUB1_REQUIERE_SUB3.has(sub1)) {
      if (!this.VALID_SUB3.includes(sub3))
        return `${fila}: Submenu3 "${row.Submenu3}" no es válido para ${sub1}. Permitidos: ${this.VALID_SUB3.join(', ')}`;
    }

    return null;
  }

  // ─── Carga masiva Excel ────────────────────────────────────────────────────
  referenciaArchivo(ev: any): void {
    this.file = ev.target.files[0];
    this.subiendoandoExcel2();
  }

  referenciaArchivoFI(ev: any): void {
    this.fechaI = moment(ev.target.value).format("YYYY-MM-DD 00:00:00");
  }

  referenciaArchivoFF(ev: any): void {
    this.fechaF = moment(ev.target.value).format("YYYY-MM-DD 23:59:59");
  }

  subiendoandoExcel2(): void {
    this.spinner.show();
    const fileReader = new FileReader();
    fileReader.onload = () => {
      this.arrayBuffer = fileReader.result;
      const data = new Uint8Array(this.arrayBuffer as ArrayBuffer);
      const arr = Array.from(data).map((d) => String.fromCharCode(d));
      const workbook = XLSX.read(arr.join(""), { type: "binary" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const MEDIDORESEXCEL: any[] = XLSX.utils.sheet_to_json(worksheet, { raw: true });

      const camposRequeridos = ["Codigo", "NUI", "Cedula", "Tipo_PQR", "Submenu1", "Submenu2", "Submenu3", "Descripcion", "Dia", "Mes", "Ano"];
      const faltante = camposRequeridos.find((c) => !MEDIDORESEXCEL[0]?.hasOwnProperty(c));

      if (faltante) {
        this.alerta.excelErr(faltante);
        this.spinner.hide();
        return;
      }

      // ── Validar tipificaciones fila por fila ────────────────────────────────
      const errores: string[] = [];
      MEDIDORESEXCEL.forEach((row: any, i: number) => {
        const err = this.validarFila(row, i);
        if (err) errores.push(err);
      });

      if (errores.length) {
        this.spinner.hide();
        this.alerta.descErr(
          `El archivo contiene ${errores.length} fila(s) con tipificaciones inválidas:\n` +
          errores.slice(0, 10).join('\n') +
          (errores.length > 10 ? `\n...y ${errores.length - 10} error(es) más.` : '')
        );
        return;
      }

      this.MEDIDORESEXCEL = MEDIDORESEXCEL;
      this.Registrar = true;
      this.spinner.hide();
      this.cdr.markForCheck();
    };
    fileReader.readAsArrayBuffer(this.file);
  }

  RegistrarExcel(): void {
    if (!this.Registrar) return;
    this.spinner.show();

    const masivo = this.MEDIDORESEXCEL.map((row: any) => ({
      idUser: this.global.Id_Usuario,
      idClient: this.idCliente || null,
      Id_Statuses: row.Codigo,
      nui: row.NUI,
      cedula: row.Cedula,
      tipo_pqr: this.normalizarTipificacion(String(row.Tipo_PQR || '')),
      submenu1: this.normalizarTipificacion(String(row.Submenu1 || '')),
      submenu2: this.normalizarTipificacion(String(row.Submenu2 || '')),
      submenu3: this.normalizarTipificacion(String(row.Submenu3 || '')),
      descripcion: row.Descripcion,
      fechaCreacion: moment(`${row.Dia}-${row.Mes}-${row.Ano}`, "DD-MM-YYYY").format("YYYY-MM-DD HH:mm:ss"),
    }));

    setTimeout(() => {
      const pdata = { option: "excel1", datos: masivo };
      this.global.consultarLocal(pdata, (err: any, response: any) => {
        this.spinner.hide();
        if (response?.success === true || response !== undefined) {
          this.alerta.descValid(response.message);
          this.listadoTickets();
        } else {
          this.alerta.descErr("Error: " + response?.message);
        }
      });
    }, 500);
  }

  // ─── Generar Excel reporte ─────────────────────────────────────────────────
async generarExcel(): Promise<void> {
    try {
      this.spinner.show();

      const pdata1 = { option: "GestionSAC",                fechaI: this.fechaI, fechaF: this.fechaF, client: this.idCliente || null };
      const pdata2 = { option: "FechaCierre",                fechaI: this.fechaI, fechaF: this.fechaF, client: this.idCliente || null };
      const pdata3 = { option: "CreationDateEQMOD",          fechaI: this.fechaI, fechaF: this.fechaF, client: this.idCliente || null };
      const pdata4 = { option: "FechaUltimaTipificacion",    fechaI: this.fechaI, fechaF: this.fechaF, client: this.idCliente || null };

      const [response1, response2, response3, response4] = await Promise.all([
        this.global.consultarFormatoSuiAsync(pdata1),
        this.global.consultarFormatoSuiAsync(pdata2),
        this.global.consultarFormatoSuiAsync(pdata3),
        this.global.consultarFormatoSuiAsync(pdata4),
      ]);

      // ── Helpers ────────────────────────────────────────────────────────────
      /** Convierte valor a ms epoch; null si inválido */
      const toMs = (val: any): number | null => {
        if (!val) return null;
        const t = new Date(val).getTime();
        return isNaN(t) ? null : t;
      };

      /** DD-MM-AAAA — usa string split para evitar timezone offset */
      const fmt = (val: any): string => {
        if (!val) return "";
        const s = String(val).substring(0, 10); // "YYYY-MM-DD"
        if (!/^\d{4}-\d{2}-\d{2}/.test(s)) return "";
        return `${s.substring(8, 10)}-${s.substring(5, 7)}-${s.substring(0, 4)}`;
      };

      // ── Mapa de fechas de cierre (pre-indexado por Id_Ticket) ─────────────
      const fechasCierreMap: Record<string, string> = {};
      for (const f of response2) {
        fechasCierreMap[f.Id_Ticket] = f.FechaCierre;
      }

      // ── Mapa fecha original EQMOD (pre-indexado por Id_Ticket) ────────────
      const eqmodMap: Record<string, string> = {};
      for (const f of response3) {
        eqmodMap[f.Id_Ticket] = f.CreationDateEQMOD;
      }

      // ── Mapa fecha última tipificación (pre-indexado por Id_Ticket) ─────
      const tipificacionMap: Record<string, string> = {};
      for (const f of response4) {
        tipificacionMap[f.Id_Ticket] = f.FechaUltimaTipificacion;
      }

      // ── Set de estados cerrados (fuera del loop para no recrear) ──────────
      const CERRADOS = new Set([6, 7, 10, 11, 12, 15, 16, 17, 18]);

      // ── Encabezados ───────────────────────────────────────────────────────
      this.Toexcel = [[
        "Id_Tickets", "Id_Gestion", "Id_Proyecto", "Id_Seccional", "Municipio", "Semaforo",
        "canal", "Menu", "SubMenu1", "SubMenu2", "SubMenu3",
        "Concatenado",
        "FechaCreacion", "Descripción", "FechaCierre", "Dias para Cierre",
        "Id_Encuesta", "Nombre_Completo", "Cedula", "Telefono", "Vereda", "NUI",
        "NombreProyecto", "NombreSeccionales", "Creador_gestion", "NombreTecnico",
        "FechaVisita", "DescrTecnico", "Semaforo en Dias",
        "IdMantenimeinto", "idTecnico", "tiposMantenimiento",
        "estadoMantenimiento", "ultimaGestionVisita",
        "CreationDateEQMOD",
        "Fecha última tipificación",
      ]];

      // ── Filas ─────────────────────────────────────────────────────────────
      for (const valor of response1) {
        const {
          Id_Tickets, Id_Gestion, Id_Proyecto, Id_Seccional, Municipio, Id_Statuses,
          canal, Menu, SubMenu1, SubMenu2, SubMenu3,
          Creation_Date, Description,
          Id_Encuesta, Nombre_Completo, Cedula, Telefono, Vereda, NUI,
          NombreProyecto, NombreSeccionales, Creador_gestion, NombreTecnico,
          FechaVisita, DescrTecnico, Semaforo, IdMantenimeinto, idTecnico,
          tiposMantenimiento, estadoMantenimiento, ultimaGestionVisita,
        } = valor;

        // Concatenado: SubMenu1 + SubMenu2 + SubMenu3 (sin Menu/Tipo)
        const concatenado = [SubMenu1, SubMenu2, SubMenu3]
          .filter(v => v && String(v).trim() !== "" && String(v).trim() !== "-")
          .join(" - ");

        // Fecha de cierre
        let fechaCierreRaw = fechasCierreMap[Id_Tickets] || null;
        if (fechaCierreRaw && String(fechaCierreRaw).startsWith("0000")) fechaCierreRaw = null;

        const esCerrado = CERRADOS.has(Number(Id_Statuses));

        // Fecha creación formateada (se usa en dos sitios, solo se computa una vez)
        const fmtCreacion = fmt(Creation_Date);

        let fechaCierre: string;
        let diasParaCierre: number;

        if (Menu?.trim() === "GESTION ESCRITA") {
          fechaCierre    = fmtCreacion;
          diasParaCierre = 0;
        } else {
          fechaCierre = fechaCierreRaw ? fmt(fechaCierreRaw) : "";

          if (esCerrado) {
            const inicioMs = toMs(Creation_Date);
            const finMs    = toMs(fechaCierreRaw) ?? Date.now();
            diasParaCierre = inicioMs != null
              ? Math.max(0, Math.floor((finMs - inicioMs) / 86400000) + 1)
              : 0;
          } else {
            diasParaCierre = Semaforo ?? 0;
          }
        }

        const estadoSemaforo = esCerrado  ? "Cerrado"
          : Semaforo <= 6                 ? "Leve"
          : Semaforo <= 14                ? "Moderado"
          : "Crítico";

        this.Toexcel.push([
          Id_Tickets, Id_Gestion, Id_Proyecto, Id_Seccional, Municipio, estadoSemaforo,
          canal, Menu, SubMenu1, SubMenu2, SubMenu3,
          concatenado,
          fmtCreacion,
          Description,
          fechaCierre,
          diasParaCierre,
          Id_Encuesta, Nombre_Completo, Cedula, Telefono, Vereda, NUI,
          NombreProyecto, NombreSeccionales, Creador_gestion, NombreTecnico,
          fmt(FechaVisita),
          DescrTecnico,
          Semaforo,
          IdMantenimeinto, idTecnico, tiposMantenimiento,
          estadoMantenimiento,
          fmt(ultimaGestionVisita),
          eqmodMap[Id_Tickets] ? fmt(eqmodMap[Id_Tickets]) : "",
          Menu?.trim() === "GESTION ESCRITA" ? fmtCreacion : (tipificacionMap[Id_Tickets] ? fmt(tipificacionMap[Id_Tickets]) : ""),
        ]);
      }

      this.excelService.exportAsExcelFile2(
        this.Toexcel,
        "Reporte asesores",
        "Reporte Asesores SAC " + Date.now().toString()
      );

    } catch (err) {
      console.error("Error en generarExcel:", err);
    } finally {
      this.spinner.hide();
    }
  }

  // ─── Descargable Provisión ───────────────────────────────────────────────
  async generarProvision(): Promise<void> {
    try {
      this.spinner.show();

      // Rango amplio para traer toda la gestión histórica
      const hoy = new Date().toISOString().slice(0, 10);
      const params = { fechaI: '2020-01-01', fechaF: hoy, client: this.idCliente || null };

      const [response, responseCierre, responseEQMOD]: any[] = await Promise.all([
        this.global.consultarFormatoSuiAsync({ option: 'GestionSAC',       ...params }),
        this.global.consultarFormatoSuiAsync({ option: 'FechaCierre',       ...params }),
        this.global.consultarFormatoSuiAsync({ option: 'CreationDateEQMOD', ...params }),
      ]);

      // Mapas para lookup rápido por Id_Ticket
      const fechaCierreMap: Record<string, string> = {};
      for (const f of responseCierre) fechaCierreMap[f.Id_Ticket] = f.FechaCierre;

      const eqmodMap: Record<string, string> = {};
      for (const f of responseEQMOD) eqmodMap[f.Id_Ticket] = f.CreationDateEQMOD;

      /** Normaliza a mayúsculas sin tildes */
      const norm = (v: any) => String(v || '').trim().toUpperCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '');

      /** Formatea fecha YYYY-MM-DD → DD-MM-AAAA */
      const fmt = (val: any): string => {
        if (!val) return '';
        const s = String(val).substring(0, 10);
        if (!/^\d{4}-\d{2}-\d{2}/.test(s)) return '';
        return `${s.substring(8, 10)}-${s.substring(5, 7)}-${s.substring(0, 4)}`;
      };

      const CERRADOS = new Set([6, 7, 10, 11, 12, 15, 16, 17, 18]);

      // ── Sets de exclusión ────────────────────────────────────────────────
      const MENUS_EXCLUIR = new Set([
        'GESTION ESCRITA', 'LLAMADA DE BIENVENIDA', 'LLAMADA OUTBOUND',
        'OUTBOUND', 'COBRO DE CARTERA', 'COMPROBANTES', 'SUSPENSION'
      ]);

      const PQRS_SUB1_EXCLUIR = new Set([
        'FACTURACION', 'CONSULTA DE INFORMACION', 'PETICION',
        'TIPO DE RESPUESTA', 'TIPO DE TRAMITE'
      ]);

      const PQRS_PRESTACION_SUB2_EXCLUIR = new Set([
        'QUEJAS ADMINISTRATIVAS', 'NO CONEXION DEL SERVICIO',
        'INTERRUPCIONES EN LA PRESTACION DEL SERVICIO',
        'INTERRUPCIONES EN LA PRESTACION DEL',
        'ESTADO DE LA INFRAESTRUCTURA'
      ]);

      const filas: any[][] = [[
        'Id_Tickets', 'Id_Gestion', 'Id_Proyecto', 'Id_Seccional', 'Municipio',
        'canal', 'Menu', 'SubMenu1', 'SubMenu2', 'SubMenu3', 'Concatenado',
        'FechaCreacion', 'FechaCierre', 'FechaIniEQ', 'Descripcion',
        'Nombre_Completo', 'Cedula', 'NUI',
        'NombreProyecto', 'NombreSeccionales', 'Creador_gestion',
        'Semaforo', 'Semaforo en Dias'
      ]];

      for (const v of response) {
        const {
          Id_Tickets, Id_Gestion, Id_Proyecto, Id_Seccional, Municipio,
          canal, Menu, SubMenu1, SubMenu2, SubMenu3,
          Creation_Date, Description, Id_Statuses, Semaforo,
          Nombre_Completo, Cedula, NUI,
          NombreProyecto, NombreSeccionales, Creador_gestion
        } = v;

        const menuN = norm(Menu);
        const sub1N = norm(SubMenu1);
        const sub2N = norm(SubMenu2);

        // ── Exclusiones globales ─────────────────────────────────────────
        if (MENUS_EXCLUIR.has(menuN)) continue;
        if (menuN.includes('COMPROBANTE')) continue;
        if (sub1N === 'COBRO DE CARTERA') continue;
        if (sub1N.includes('COMPROBANTE')) continue;

        // ── Concatenado y filtros por menú ───────────────────────────────
        let concatenado = '';

        if (menuN === 'FACTURACION') {
          if (sub1N !== 'INCONFORMIDAD CON FACTURACION') continue;
          concatenado = SubMenu1 || '';

        } else if (menuN === 'GESTION SOCIAL') {
          if (sub1N === 'CONTACTADO') continue;
          concatenado = [SubMenu1, SubMenu2, SubMenu3]
            .filter(x => x && String(x).trim() && String(x).trim() !== '-').join(' - ');

        } else if (menuN.includes('NOVEDAD') || menuN.includes('SOLUCION')) {
          concatenado = SubMenu1 || '';

        } else if (menuN === 'OTROS') {
          if (sub1N === 'GESTION DE CARTERA' || sub1N === 'LLAMADA DE INFORMACION') continue;
          concatenado = SubMenu2 || '';

        } else if (menuN === 'QUEJA') {
          concatenado = SubMenu1 || '';

        } else if (menuN === 'RECLAMO') {
          const sub2Norm = norm(SubMenu2);
          if (sub1N === 'DANO' && (sub2Norm === 'EQUIPOS MODIFICADOS(HOMOLOGACION)' || sub2Norm === 'SISFV NO ENCONTRADA')) {
            concatenado = SubMenu2 || '';
          } else {
            concatenado = SubMenu1 || '';
          }

        } else if (menuN === 'PETICION') {
          if (sub1N.includes('COMPROBANTE') || sub1N.includes('SOLICITUD DE FACTURA') || sub1N === 'CONSULTA DE INFORMACION') continue;
          concatenado = SubMenu1 || '';

        } else if (menuN === 'PQRS' || menuN.includes('PQRS')) {
          if (PQRS_SUB1_EXCLUIR.has(sub1N)) continue;
          if (sub1N.includes('PRESTACION')) {
            if (PQRS_PRESTACION_SUB2_EXCLUIR.has(sub2N) || sub2N.includes('INTERRUPCIONES')) continue;
            concatenado = SubMenu2 || '';
          } else {
            concatenado = SubMenu1 || '';
          }

        } else {
          concatenado = [SubMenu1, SubMenu2, SubMenu3]
            .filter(x => x && String(x).trim() && String(x).trim() !== '-').join(' - ');
        }

        const esCerrado = CERRADOS.has(Number(Id_Statuses));
        const estadoSemaforo = esCerrado ? 'Cerrado'
          : Semaforo <= 6               ? 'Leve'
          : Semaforo <= 14              ? 'Moderado'
          : 'Crítico';

        filas.push([
          Id_Tickets, Id_Gestion, Id_Proyecto, Id_Seccional, Municipio,
          canal, Menu, SubMenu1, SubMenu2, SubMenu3, concatenado,
          fmt(Creation_Date),
          fmt(fechaCierreMap[Id_Tickets] || ''),
          eqmodMap[Id_Tickets] ? fmt(eqmodMap[Id_Tickets]) : '',
          Description,
          Nombre_Completo, Cedula, NUI,
          NombreProyecto, NombreSeccionales, Creador_gestion,
          estadoSemaforo, Semaforo
        ]);
      }

      // ── Ordenar por Menú alfabéticamente (saltando la cabecera) ─────────
      const cabecera = filas[0];
      const datos    = filas.slice(1).sort((a, b) => String(a[6]).localeCompare(String(b[6]), 'es'));

      this.excelService.exportAsExcelFile2(
        [cabecera, ...datos],
        'Descargable Provision',
        'Descargable_Provision_' + Date.now()
      );

    } catch (err) {
      console.error('Error en generarProvision:', err);
    } finally {
      this.spinner.hide();
    }
  }

  // ─── DataTable (solo si realmente se necesita para exportar) ──────────────
  private destruirDataTable(): void {
    if (this.dtInstance) {
      try { this.dtInstance.destroy(); } catch {}
      this.dtInstance = null;
    }
  }
}